import isUserRole from '../purchase-orders/is-user-role'
import {_rep} from '../cads/unminify'
import {unminifyCategory, accountName} from '../cads/unminify'


const filterSalesData = (salesData, cads, user, shareOrderTypeCategory, isShipped) => {
  let {isAdmin, isProduction, isInventory, isSales, isSalesAssistant, isCustomer} = isUserRole(user)

  const emails = (() => {
    if (isSalesAssistant) {
      return user.salesAdminEmails
    } else if (isSales) {
      if (user.salesAdminIds.length > 0) {
        return [user.email].concat(user.salesAdminEmails)
      } else {
        return [user.email]
      }
    } else {
      return []
    }
  })().map(x => x.replace('_sales',''))

  if (isAdmin || isProduction || isInventory || isCustomer) {
    return salesData
  } else {
    let result = {}

    let shareOrderType = shareOrderTypeCategory == null ? null : shareOrderTypeCategory.split(' on ')[0]
    let shareCategory = shareOrderTypeCategory == null ? null : shareOrderTypeCategory.split(' on ')[1]

    let cadsHash = {}
    if (shareOrderTypeCategory != null) {
      cads.forEach((cad) => {
        const val = unminifyCategory(cad.g)

        if (cad.i != null) {
          cadsHash[cad.i] = val
        }
        if (cad.s != null) {
          cadsHash[cad.s] = val
        }
      })
    }


    Object.keys(salesData).forEach((key) => {
      //get orders that match emails
      let orders = salesData[key].filter(order => emails.includes(_rep(order)) || shareOrderTypeCategoryMatch(order, shareOrderType, shareCategory, key, cadsHash, isShipped) )

      if (orders.length > 0) {
        result[key] = orders
      }
    })

    return result
  }
}

const shareOrderTypeCategoryMatch = (order, shareOrderType, shareCategory, key, cadsHash, isShipped) => {
  if (shareOrderType == null) {
    return false
  } else {
    let orderType = isShipped ? 'Shipped' : 'PO'

    if (!isShipped) {
      if (!!order.hold) {
        orderType = 'Hold'
      } else if (!!order.worksheet) {
        orderType = 'Worksheet'
      }
    }

    const orderTypeMatch = orderType == shareOrderType || shareOrderType == 'All'

    if (!orderTypeMatch) {
      return false
    } else {
      if (shareCategory.includes('%')) {
        let shareAccountNames = shareCategory.split(', ')
        let _accountName = accountName(order)
        return _accountName != null && shareAccountNames.some(shareAccountName => _accountName.startsWith(shareAccountName.split('%')[0]) )
      } else {
        const cadCategory = cadsHash[key] || cadsHash[Number(key)]

        if (cadCategory == null) {
          return false
        } else {
          const categoryMatch = cadCategory == shareCategory
          return categoryMatch
        }
      }
    }
  }
}

export {filterSalesData}
